'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCurrencySymbolOnLeft = exports.getISOCodeForCurrencySymbol = exports.getCurrencySymbolForISOCode = exports.formatPriceBySymbol = exports.formatPrice = undefined;

var _formatter = require('./formatter');

var _currency = require('./currency');

exports.formatPrice = _formatter.formatPrice;
exports.formatPriceBySymbol = _formatter.formatPriceBySymbol;
exports.getCurrencySymbolForISOCode = _currency.getCurrencySymbolForISOCode;
exports.getISOCodeForCurrencySymbol = _currency.getISOCodeForCurrencySymbol;
exports.isCurrencySymbolOnLeft = _currency.isCurrencySymbolOnLeft;
exports.default = {
  formatPrice: _formatter.formatPrice,
  formatPriceBySymbol: _formatter.formatPriceBySymbol,
  getCurrencySymbolForISOCode: _currency.getCurrencySymbolForISOCode,
  getISOCodeForCurrencySymbol: _currency.getISOCodeForCurrencySymbol,
  isCurrencySymbolOnLeft: _currency.isCurrencySymbolOnLeft
};
//# sourceMappingURL=index.js.map